export function buildEffectiveSelectedTreeNodeIds(
  selectedTreeNodeIds: string[],
  currentDocumentId: string | null,
): string[] {
  // Sidebar visuals can imply the active manuscript is selected, but only true multi-select
  // should broaden grounding scope. Keep single-node selection strict to user intent.
  const hasExplicitMultiSelection = selectedTreeNodeIds.length > 1;
  if (!hasExplicitMultiSelection || !currentDocumentId || selectedTreeNodeIds.includes(currentDocumentId)) {
    return selectedTreeNodeIds;
  }
  return [...selectedTreeNodeIds, currentDocumentId];
}

export function buildSidebarMentionNodeIds(params: {
  selectedTreeNodeIds: string[];
  selectionProjectId: string | null;
  viewedProjectId: string | null;
  chatProjectId: string | null;
  currentDocumentId: string | null;
}): string[] {
  const {
    selectedTreeNodeIds,
    selectionProjectId,
    viewedProjectId,
    chatProjectId,
    currentDocumentId,
  } = params;

  // Only use sidebar tree selections when the visible sidebar project and chat owner
  // project are the same. This avoids injecting document::/folder:: tags from another
  // Firebase project in series/folder chat contexts.
  const canUseSidebarSelectionForChat =
    !!chatProjectId
    && viewedProjectId === chatProjectId
    && selectionProjectId === chatProjectId;

  if (!canUseSidebarSelectionForChat) return [];
  return buildEffectiveSelectedTreeNodeIds(selectedTreeNodeIds, currentDocumentId);
}
